<div class="error">
  <h2>{{ "api.errors.error" | translate }}</h2>
  <p>{{ message | translate }}</p>
</div>

<app-change-lang *ngIf="!isLoggedIn"></app-change-lang>
